import { Store } from '@stores/Store'

export class SummaryCalculation2024 {
  store!: Store

  constructor(store: Store) {
    this.store = store
  }

  // Summary Total Income 2024

  get totalCorePlusMonthlyAmount2024() {
    const { store } = this
    const { bronzeFoundationMonthlyBonusAmount, bronzeBuilderMonthlyBonusAmount } = store.bronzeIncentiveCalculation
    const { performanceMonthlyAmount } = store.performanceIncentiveCalculation
    const { personalGroupGrowthMonthlyAmount } = store.personalGroupGrowthIncentiveCalculation

    return bronzeFoundationMonthlyBonusAmount + bronzeBuilderMonthlyBonusAmount +
      performanceMonthlyAmount + personalGroupGrowthMonthlyAmount
  }

  get totalCorePlusAnnualAmount2024() {
    const { store } = this
    const { bronzeFoundationAnnualBonusAmount, bronzeBuilderAnnualBonusAmount } = store.bronzeIncentiveCalculation
    const { bronzeBuilderConsitencyIncentiveAmount } = store.bronzeConsistencyIncentiveCalculation
    const { performanceAnnualAmount } = store.performanceIncentiveCalculation
    const { personalGroupGrowthAmount } = store.personalGroupGrowthIncentiveCalculation
    const { frontlineGrowthIncentive } = store.frontlineGrowthIncentiveCalculation
    const { twoTimeCashIncentiveAmount } = store.twoTimeCashIncentiveCalculation

    return bronzeFoundationAnnualBonusAmount + bronzeBuilderAnnualBonusAmount +
      bronzeBuilderConsitencyIncentiveAmount + performanceAnnualAmount +
      personalGroupGrowthAmount + frontlineGrowthIncentive + twoTimeCashIncentiveAmount
  }

  get totalIncomeMonthlyAmount2024() {
    const { store } = this
    const { summaryCalculation } = store
    const { totalCorePlanIncomeMonthlyAmount } = summaryCalculation
    const { bronzeFoundationMonthlyBonusAmount, bronzeBuilderMonthlyBonusAmount } = store.bronzeIncentiveCalculation
    const { performanceMonthlyAmount } = store.performanceIncentiveCalculation
    const { personalGroupGrowthMonthlyAmount } = store.personalGroupGrowthIncentiveCalculation

    return totalCorePlanIncomeMonthlyAmount +
      bronzeFoundationMonthlyBonusAmount + bronzeBuilderMonthlyBonusAmount +
      performanceMonthlyAmount + personalGroupGrowthMonthlyAmount
  }

  get totalIncomeAnnualAmount2024() {
    const { store } = this
    const { summaryCalculation } = store
    const { totalCorePlanIncomeAnnualAmount } = summaryCalculation
    const { bronzeFoundationAnnualBonusAmount, bronzeBuilderAnnualBonusAmount } = store.bronzeIncentiveCalculation
    const { bronzeBuilderConsitencyIncentiveAmount } = store.bronzeConsistencyIncentiveCalculation
    const { performanceAnnualAmount } = store.performanceIncentiveCalculation
    const { personalGroupGrowthAmount } = store.personalGroupGrowthIncentiveCalculation
    const { frontlineGrowthIncentive } = store.frontlineGrowthIncentiveCalculation
    const { twoTimeCashIncentiveAmount } = store.twoTimeCashIncentiveCalculation

    return totalCorePlanIncomeAnnualAmount +
      bronzeFoundationAnnualBonusAmount + bronzeBuilderAnnualBonusAmount + bronzeBuilderConsitencyIncentiveAmount +
      performanceAnnualAmount + personalGroupGrowthAmount + frontlineGrowthIncentive + twoTimeCashIncentiveAmount
  }

}
